import { gql } from '@apollo/client';

export const GET_ARTICLES = gql`
  query GetArticleForStore($input: ArticleStoreFilterInput!) {
    getArticleForStore(input: $input) {
      entities {
        id
        content
        createdAt
        hashtags {
          id
          name
        }
        imageLabel
        key
        slug
        status
        store {
          slug
          storeDetails {
            storeName
          }
        }
        title
        url
      }
      limit
      offset
      total
    }
  }
`;

export const GET_ARTICLES_BY_HASHTAG = gql`
  query GetArticlesByHashtag($input: ArticlesByHashtagInput!) {
    getArticlesByHashtag(input: $input) {
      items {
        id
        createdAt
        slug
        status
        store {
          slug
          storeDetails {
            storeName
          }
        }
        title
        url
      }
      startAfter
    }
  }
`;

export const GET_ARTICLE_BY_SLUG = gql`
  query GetArticleBySlug($input: ArticleBySlugInput!) {
    getArticleBySlug(input: $input) {
      articleUrl
      id
      content
      createdAt
      hashtags {
        id
        name
      }
      mentions {
        id
        mentionType
        targetType
        store {
          slug
          id
          role
          firstName
          lastName
          storeDetails {
            storeName
            storeId
            avatarURL
          }
        }
        unregisteredContact {
          id
          email
          representativeName
          phoneNumber
          name
          url
          type
          socialMediaLink
        }
      }
      imageLabel
      key
      slug
      status
      store {
        slug
        storeDetails {
          storeName
          avatarURL
        }
      }
      title
      url
      updatedAt
      metaDescription
      keyTakeaways
      faq {
        question
        answer
      }
      focusKeyword
      imageAlt
      sourceInterviewer {
        slug
        firstName
        lastName
        storeDetails {
          storeName
          avatarURL
        }
      }
      sourceInterviewee {
        slug
        firstName
        lastName
        storeDetails {
          storeName
          avatarURL
        }
      }
      sourceStream {
        id
        slug
        name
        imageURL
        scheduleDateUtc
        price
        store {
          slug
          storeDetails {
            storeName
          }
        }
      }
    }
  }
`;
